module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    attrs: {
      "ng-form": "payTypSolicForm"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('forma de pagamento')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "forma de pagamento"
    }
  }, [_vm._v("Forma de pagamento:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 "
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.forma_pagamento),
      expression: "nota.forma_pagamento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.validacao.processo.nome === 'Prestação de Contas' || _vm.validacao.processo.nome === 'PRESTACAO_DE_CONTAS',
      "name": "forma de pagamento"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.nota, "forma_pagamento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.validacao.processo.nome === 'Prestação de Contas' || _vm.validacao.processo.nome === 'PRESTACAO_DE_CONTAS') ? _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Crédito Conta Beneficiário")]) : _vm._e(), _vm._v(" "), (_vm.validacao.processo.nome !== 'Prestação de Contas' && _vm.validacao.processo.nome !== 'PRESTACAO_DE_CONTAS') ? _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Crédito Conta Fornecedor")]) : _vm._e(), _vm._v(" "), (_vm.validacao.processo.nome !== 'Prestação de Contas' && _vm.validacao.processo.nome !== 'PRESTACAO_DE_CONTAS') ? _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Docum. Código de Barras")]) : _vm._e()])]), _vm._v(" "), (_vm.errors.first('forma de pagamento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('forma de pagamento')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
      expression: "usuarioLogado.userType === 'FUNDACAO'"
    }],
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('pagamento prioritário')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "pagamento prioritário"
    }
  }, [_vm._v("Pagamento Prioritário:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.prioridade),
      expression: "nota.prioridade"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "pagamento prioritário"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.nota, "prioridade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Sim")])])]), _vm._v(" "), (_vm.errors.first('pagamento prioritário')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('pagamento prioritário')))]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Forma de pagamento")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43c30592!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacoes/modulos/formaPagamento.vue
// module id = 1841
// module chunks = 2